export const moduleName = 'HFT';
export const HFTConfigUrl = './manifest.json';


// WEBPACK FOOTER //
// ./src/redux/modules/hft/constants.tsx